import cacheableRequest from '../../../services/cacheableRequest';
import { AxiosResponse } from 'axios';
import { Volume } from '../models/volume';

export const getVolume = (curriculumId: string) =>
  cacheableRequest(`/author/curriculum/volumes/${curriculumId}`).then(
    (response: AxiosResponse<Volume>) => response.data
  );
